export enum SellerRole {
    VIEW_ALL_LEADS = 'view_all_leads',
    REASSIGN_LEADS = 'reassign_leads',
    REMOVE_LEADS = 'remove_leads',
    MANAGE_USERS = 'manage_users'
}
